import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import { FaChevronDown } from "react-icons/fa";

const CustomDatePicker = ({
  selected,
  onChange,
  placeholder,
  dateFormat = "dd/MM/yyyy",
  className = "",
  ...rest
}) => {
  const wrapperRef = useRef(null);

  const handleCalendarOpen = () => {
    // Defer until popper is rendered
    setTimeout(() => {
      const popper = document.querySelector(".react-datepicker-popper");
      if (!popper) return;

      const rect = popper.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;

      let scrollDelta = 0;
      const padding = 16;

      // If calendar bottom is cut off, scroll down enough
      if (rect.bottom > viewportHeight) {
        scrollDelta = rect.bottom - viewportHeight + padding;
      }

      // If calendar top is above viewport, scroll up
      if (rect.top < 0) {
        scrollDelta = rect.top - padding;
      }

      if (scrollDelta !== 0) {
        window.scrollBy({
          top: scrollDelta,
          behavior: "smooth",
        });
      }
    }, 0);
  };

  return (
    <div className="relative w-full" ref={wrapperRef}>
      <DatePicker
        selected={selected}
        onChange={onChange}
        placeholderText={placeholder}
        dateFormat={dateFormat}
        className={
          className ||
          "p-2 pr-8 bg-[#F6F6F6] border-[1px] border-black rounded-md focus:outline-none w-full cursor-pointer"
        }
        calendarClassName="z-50"
        popperPlacement="bottom-start"
        onCalendarOpen={handleCalendarOpen}
        wrapperClassName="w-full"
        {...rest}
      />

      {/* Chevron icon */}
      <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500">
        <FaChevronDown />
      </div>
    </div>
  );
};

export default CustomDatePicker;